import { store } from "@/store";
import { RequestEnum, ServiceGateWay } from "@/utils/enum";
import axios from "@/utils/request";
const UserLogin = `${ServiceGateWay.REGISTEREDUSER}/RegisteredUserExamer`;
const RandomVerificationCodeService = `${ServiceGateWay.REGISTEREDUSER}/RandomVerificationCodeService`;

const Login = {
  GET: {
    isUserPhoneExist(phone: string, code: string) {
      return axios({
        url: `${UserLogin}/ExistPhone/${phone}`,
        params: {
          code: code,
        },
        options: {
          tenantId: undefined,
        },
      });
    },
    // 获取临时Token
    async getTmpToken() {
      const token = await axios({ url: `${ServiceGateWay.ZhuoFan_Wb_RegisteredUserService_WebApi}/api/LoginUserExamer/TempUserToken`, options: { token: "" } });
      store.commit("SET_DATA", { name: "token", data: token });
      return token;
    },
    // 登录获取验证码
    getRandomVerificationCodeMd5(randomMark: string) {
      return axios({
        url: `${RandomVerificationCodeService}/RandomVerification/${randomMark}`,
        options: {
          tenantId: undefined,
        },
      });
    },
  },
  POST: {
    // 发送验证码（合并）
    getSMSCode(data) {
      return axios({
        url: `${UserLogin}`,
        method: RequestEnum.POST,
        data,
        options: {
          noTransform: true,
          tenantId: undefined,
        },
      });
    },
    getLoginSMSCode(data) {
      return axios({
        url: `${UserLogin}/LoginCode`,
        method: RequestEnum.POST,
        data,
        options: {
          noTransform: true,
          tenantId: undefined,
        },
      });
    },
    getRegisterSMSCode(data) {
      return axios({
        url: `${UserLogin}/RegisterCode`,
        method: RequestEnum.POST,
        data,
        options: {
          noTransform: true,
          tenantId: undefined,
        },
      });
    },
    getResetPasswordCode(data) {
      return axios({
        url: `${UserLogin}/ResetPasswordCode`,
        method: RequestEnum.POST,
        data,
        options: {
          noTransform: true,
          tenantId: undefined,
        },
      });
    },
    isSMSCodeValid(data) {
      return axios({
        url: `${UserLogin}/isvalid`,
        method: RequestEnum.POST,
        data,
        options: {
          noTransform: true,
          tenantId: undefined,
        },
      });
    },
  },
  PATCH: {
    resetPassword(data: any) {
      return axios({
        url: `${ServiceGateWay.REGISTEREDUSER}/RecoverUserExamer/ResetPassword`,
        method: RequestEnum.PATCH,
        data,
        options: {
          noTransform: true,
          tenantId: undefined,
        },
      });
    },
  },
};

export default { Login };
